import axios from 'axios';
const headers = {};
const axiosInstance = axios.create({ headers });
export const paymentMeanDetailsModalService = {
    callKlarna: ({ price }) => {
        const url = `/restpublic/web/klarna/messaging?amount=${price}`;
        try {
            return axiosInstance.get(url, {
                withCredentials: true,
            });
        }
        catch (err) {
            console.log(`error: ${err}`);
            throw err;
        }
    },
    callFloa: ({ price }) => {
        const url = `/restpublic/web/payment-means/${price}`;
        try {
            return axiosInstance.get(url, {
                withCredentials: true,
            });
        }
        catch (err) {
            console.log(`error: ${err}`);
            throw err;
        }
    },
};
